import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { PageHeader } from '../components/Layout';
import { GlassCard } from '../components/ui';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  category: 'General',
  questions: [{
    q: 'What is KDX?',
    a: 'KDX is a digital platform for gaming and payment services. We provide access to game top-ups, gift cards, airtime, data, utility payments, and marketplace transactions all in one secure platform.'
  }, {
    q: 'How are payments processed?',
    a: 'Payments are processed through secure payment processors. All transactions are encrypted and processed through certified payment gateways to ensure your financial information is protected.'
  }, {
    q: 'Is KDX secure?',
    a: 'Yes, KDX uses secure systems and compliance measures. We implement industry-standard security protocols, encryption, and work with certified payment processors to protect your data and transactions.'
  }, {
    q: 'How fast are transactions?',
    a: 'Most transactions are processed instantly. Digital services like game top-ups, gift cards, and airtime are typically delivered within seconds of payment confirmation.'
  }]
}, {
  category: 'Account & Security',
  questions: [{
    q: 'How do I create an account?',
    a: "Download the KDX app from the App Store or Google Play, then follow the registration process. You'll need to provide basic information and verify your email or phone number."
  }, {
    q: 'What if I forget my password?',
    a: "Use the 'Forgot Password' option on the login screen. You'll receive a password reset link via email or SMS to securely reset your password."
  }, {
    q: 'Is identity verification required?',
    a: 'KDX may require identity verification (KYC) to comply with regulatory requirements and prevent fraud. This helps ensure the security of all users on the platform.'
  }]
}, {
  category: 'Payments & Wallet',
  questions: [{
    q: 'How do wallet top-ups work?',
    a: 'You can fund your KDX wallet using cards, bank transfers, or mobile money. Wallet funds can be used for faster checkout and may qualify for exclusive deals.'
  }, {
    q: 'What payment methods are accepted?',
    a: 'We accept major credit/debit cards, bank transfers, USSD, and mobile money depending on your region. All payments are processed securely through our payment partners.'
  }, {
    q: 'Are there any fees?',
    a: 'All prices displayed are final unless otherwise stated. Applicable fees, taxes, or charges may apply depending on the service and payment method selected.'
  }]
}, {
  category: 'Refunds & Support',
  questions: [{
    q: 'Can I get refunds?',
    a: 'Refunds are only applicable for failed, incomplete, or duplicate transactions. Successfully completed transactions are non-refundable unless required by law.'
  }, {
    q: 'How do I contact support?',
    a: 'You can reach our support team via email at kdx.limited.ng@gmail.com or through the in-app support feature. We handle all support requests within a reasonable timeframe.'
  }, {
    q: 'What if my transaction fails?',
    a: "If your transaction fails, the amount will be automatically refunded to your original payment method or KDX wallet. Contact support if you don't receive your refund within the expected timeframe."
  }]
}];
export const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState<string | null>('General-0');
  const toggleFaq = (id: string) => {
    setOpenIndex(openIndex === id ? null : id);
  };
  return <div className="min-h-screen bg-[#050810]" data-id="element-259">
      <PageHeader title="Frequently Asked Questions" description="Find answers to common questions about using KDX." data-id="element-260" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-261">
        {faqs.map((section, sIdx) => <div key={sIdx} className="mb-12" data-id="element-262">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 pl-2 border-l-4 border-purple-500" data-id="element-263">
              {section.category}
            </h2>
            <div className="space-y-4" data-id="element-264">
              {section.questions.map((faq, qIdx) => {
            const id = `${section.category}-${qIdx}`;
            const isOpen = openIndex === id;
            return <GlassCard key={qIdx} className="p-0 overflow-hidden border-white/10" hover={false} data-id="element-265">
                    <button className="w-full text-left p-6 flex items-center justify-between focus:outline-none hover:bg-white/[0.02] transition-colors" onClick={() => toggleFaq(id)} data-id="element-266">
                      <span className="font-semibold text-white pr-8 text-base md:text-lg" data-id="element-267">
                        {faq.q}
                      </span>
                      <ChevronDown className={`w-5 h-5 text-purple-400 transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-268" />
                    </button>
                    <AnimatePresence data-id="element-269">
                      {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-270">
                          <div className="px-6 pb-6 text-gray-300 leading-relaxed border-t border-white/5 pt-4" data-id="element-271">
                            {faq.a}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </GlassCard>;
          })}
            </div>
          </div>)}
      </div>
    </div>;
};